// extracted by mini-css-extract-plugin
export const dialogContent = "styles-module--dialogContent--WMbT2";
export const promoCodeButton = "styles-module--promoCodeButton--ARICc";
export const promoCodeTerms = "styles-module--promoCodeTerms--mG1-4";
export const promoCodeCardTitle = "styles-module--promoCodeCardTitle--s+EK-";
export const promoCodeCardExpired = "styles-module--promoCodeCardExpired--Js3oE";
export const promoCodeCardBody = "styles-module--promoCodeCardBody--aQKIX";
export const dialog = "styles-module--dialog--g5HDZ";